// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1WNjB","errorLogs":"EditorFooter_errorLogs__3Fn7L"};